import { CreateReportModal } from "./components/Dialog";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ClientReportCreateModalOptions, ClientReportCreateModalProps } from "./types";
import { ClientReportType } from "../../../types/ClientReportType";

export function openCreateClientReportModal(opts: ClientReportCreateModalOptions) {
    return createConfirmation<ClientReportCreateModalProps, ClientReportType>(confirmable(CreateReportModal))({
        adviserId: opts.adviserId,
        allowedReportTypeOptions: opts.allowedReportTypeOptions,
        defaultValues: {
            isRecommendationsGenerated: opts.createBusinessSheet ?? false,
            borrowRecommendationsId: null,
            masterAccountId: opts.masterAccountId,
            projectId: opts.projectId ?? null,
            authorId: opts.authorId ?? null,
            reportName: '',
            templateId: null,
            typeId: opts.typeId ?? '726cccc43a4e421186f8ccdcb8945088',
            deadlineDate: null,
            estimatedMinutesToComplete: 0,
            reviewId: opts.reviewId ?? null,
            categories: [],
            productAreas: [] 
        },
        dialogId: 'create_client_report_modal',
        divisionId: opts.divisionId,
        hideProjectOnReviewSet: opts.hideProjectOnReviewSet ?? true,
        masterAccountId: opts.masterAccountId
    });
}